import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import {
    IDynamicLinkedServiceTypeMetadata,
    ILinkedServiceTypeMetadata
} from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { sharedDynamicsMetadata } from '../consts/metadata-consts';
import { DatasetFormatType } from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';
import { getDataflowDynamicsSink, getDataflowDynamicsSource, onetimeQueryTemplate } from './dynamics-metadata';
import { ConnectionAuthKind } from 'shell-models-lib';
import { DataSourceOptionKind, CommonResourceKind as ResourceKind } from '@powerquery/mashup-editor-client';
import { compact } from 'lodash';
import { GlobalVariables } from 'app/services/globals';

export const dynamicsCrmMetadata: IDynamicLinkedServiceTypeMetadata = async (injector) => {
    const metadata: ILinkedServiceTypeMetadata = {
        type: adfModelTypeMap.dynamicsCRM.linkedServiceType,
        displayName: stringResources.DynamicsCRM_DisplayText,
        linkedServiceKind: 'table',
        icon: {
            className: 'svg-i-100x100-dynamics_crm'
        },
        isFirstClass: true,
        supportDatasetV2: true,
        supportDataFlowSource: true,
        supportDataFlowSink: true,
        supportFirstClassParameterExperience: true,
        supportedInTrident: true,
        supportAutoFillCopilotInput: true,
        isKnownInPipelineContext: true,
        supportOPDG: GlobalVariables.enableOPDG,
        pqoDataSourceOption: {
            kind: DataSourceOptionKind.Extension,
            resourceKind: 'DynamicsCrm' as ResourceKind
        },
        supportedAuthKindsInTrident: compact([
            ConnectionAuthKind.ServicePrincipal,
            ConnectionAuthKind.WorkspaceIdentity
        ]),
        supportCopyJobSource: true,
        supportCopyJobSink: true,
        supportedJobModesAsSource: GlobalVariables.copyJobIncrementalCopyPhase2 ? undefined : ['Batch'],
        dataflowSource: [
            getDataflowDynamicsSource(DatasetFormatType.DynamicsCRM, adfModelTypeMap.dynamicsCRM.dataflowSettings)
        ],
        dataflowSink: [
            getDataflowDynamicsSink(DatasetFormatType.DynamicsCRM, adfModelTypeMap.dynamicsCRM.dataflowSettings)
        ],
        tableNameAlias: 'entityName',
        onetimeQueryTemplate,
        timedQueryTemplate: '<fetch>\n'
            + '<entity name="<<tableName>>">\n'
            + '<all-attributes />\n'
            + '<filter type="and">\n'
            + '<condition attribute ="<<columnName>>" operator="between">\n'
            + '<value>@{formatDateTime(pipeline().parameters.windowStart, \'yyyy-MM-dd HH:mm\')}</value>\n'
            + '<value>@{formatDateTime(pipeline().parameters.windowEnd, \'yyyy-MM-dd HH:mm\')}</value>\n'
            + '</condition>\n'
            + '</filter>\n'
            + '</entity>\n'
            + '</fetch>\n',
        deltaLoadQueryTemplate: '<fetch>\n'
            + '<entity name="<<tableName>>">\n'
            + '<all-attributes />\n'
            + '<filter type="and">\n'
            + '<condition attribute ="<<columnName>>" operator="between">\n'
            + '<value><<startValue>></value>\n'
            + '<value><<endValue>></value>\n'
            + '</condition>\n'
            + '</filter>\n'
            + '</entity>\n'
            + '</fetch>\n',
        fetchTableNameFromItemPath: true,
        copySinkTypes: [adfModelTypeMap.dynamicsCRM.copySinkType],
        copySourceTypes: [adfModelTypeMap.dynamicsCRM.copySourceType],
        category: ['ServicesApps'],
        controls: sharedDynamicsMetadata
    };

    return metadata;
};
